import React from "react";
import { AdminLoginForm } from "Forms/AdminLoginForm/AdminLoginForm";
import logoIcon from "../../Recursos/genesis_logo_icon.webp";
import logoFull from "../../Recursos/genesis_logo_full.webp";
import character_2_desktop from "../../Recursos/character_2_desktop.webp";
import character_2_mobile_tablet from "../../Recursos/character_2_mobile_tablet.webp";
import { useMobile } from "../../Hooks/useMobile";
import { useDesktop } from "Hooks/useDesktop";
import { paramService } from "Services/param_service";
import { useQuery } from "Hooks/useQuery";
import "./AdminLogin.scss";

export const AdminLogin = () => {
  const { data: images } = useQuery(paramService.param, {
    grupo: "imagenes",
    files: true,
  });

  const getUrlValue = (codigo) => {
    return (
      images?.data?.find((item) => item.codigoParametro === codigo)?.url || "#"
    );
  };

  const logoTabletUp = getUrlValue("logo_genesis");
  const logoMobile = getUrlValue("logo_mobile");

  const isMobile = useMobile();
  const logoSrc = isMobile ? logoMobile : logoTabletUp;
  const isDesktop = useDesktop();
  const characterSrc = isDesktop
    ? character_2_desktop
    : character_2_mobile_tablet;

  return (
    <div className="admin-login">
      <div className="admin-login__container">
        <div className="admin-login__header">
          <div className="admin-login__logo">
            <img
              src={logoSrc}
              alt="Genesis Logo"
              onError={(e) => {
                e.target.src = isMobile ? logoIcon : logoFull;
              }}
            />
          </div>
        </div>
        <div className="admin-login__cintillo" />
        <div className="admin-login__body">
          <div className="admin-login__content">
            <h2 className="admin-login__title-mobile heading-l-bold mb-0">
              ¡Hola, bienvenido de vuelta!
            </h2>

            <div className="admin-login__image">
              <img
                src={characterSrc}
                alt="Genesis Character"
                className="admin-login__character"
              />
            </div>

            <div className="admin-login__form-section">
              <h2 className="admin-login__title-tablet-desktop">
                ¡Hola, bienvenido de vuelta!
              </h2>

              <AdminLoginForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
